import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import {
  agentGet,
  agentUpdate
} from "../../../actions/agent";
import {
  getMajorCompanies
} from "../../../actions/customer";
import { getUser } from "../../../actions/user";
import { CustomerAgentProfile } from "../../../components/Customer/Agent";
import responseHandler from "responseHandler";

const mapStateToProps = (state) => {
  return {
    agentDetails: state.customer.agentDetails,
    majorCompanies: state.customer.majorCompanies,
    canEdit: state.user.profile.rights.indexOf("Customer Agent Edit") >= 0,
    internetUser: state.user.internetUser,
  };
};

const mapDispatchToProps = dispatch => ({
  agentGet(id) {
    dispatch(agentGet(id));
  },
  agentUpdate(agentInfo) {
    dispatch(agentUpdate(agentInfo));
  },
  getMajorCompanies() {
    dispatch(getMajorCompanies());
  },
  makeToast(text) {
    responseHandler.customToast(text, "error", dispatch);
  },
  getUser(id) {
    dispatch(getUser(id));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(CustomerAgentProfile));
